exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./ciq_bg.jpg"));

// Module
exports.push([module.id, ".PairDevicePage-eec41c69{background:url(" + ___CSS_LOADER_URL___0___ + ") center/cover;min-height:calc(100vh - 60px);padding:5vh 0}.PairDevicePage-eec41c69 .container-f8d08b7a{text-align:center}.PairDevicePage-eec41c69 p{margin-bottom:20px}.Modal-c8f7b48b{width:410px;max-width:96%;margin:0 auto}.Login-221e77fc{max-width:410px;margin:0 auto}.error-0ad89297{color:#d20007}\n", ""]);

// Exports
exports.locals = {
	"PairDevicePage": "PairDevicePage-eec41c69",
	"container": "container-f8d08b7a",
	"Modal": "Modal-c8f7b48b",
	"Login": "Login-221e77fc",
	"error": "error-0ad89297"
};